module.exports = __webpack_public_path__ + "img/print-jcqzwxpay.61758b51.png";